import { PartnerLogos } from "../data";
import SubLayout from "../common/subLayout";

const Partners = (): JSX.Element => {
  return (
    <SubLayout
      _style="max-w-6xl mx-auto"
      text="Our Trusted Partners"
      subText="Our mission and vision is to build a sustainable future in which waste recycling is entrenched in every individual, organization, and community."
    >
      <div className="my-10">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-6">
          {PartnerLogos.map((logo, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 p-4 flex items-center justify-center h-24 md:h-32 border border-gray-100 hover:border-green-200 group"
            >
              <img
                className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-110"
                src={logo}
                alt={`Partner ${index + 1}`}
              />
            </div>
          ))}
        </div>
      </div>
    </SubLayout>
  );
};

export default Partners;